import { jsx as _jsx } from "react/jsx-runtime";
import { useEllipsePosition } from '../../hooks';
export default function Ellipse(props) {
    const { cx: oldCx, cy: oldCy, rx: oldRx, ry: oldRy, ...otherProps } = props;
    const { cx, cy, rx, ry } = useEllipsePosition({
        cx: oldCx,
        cy: oldCy,
        rx: oldRx,
        ry: oldRy,
    });
    return _jsx("ellipse", Object.assign({ cx: cx, cy: cy, rx: rx, ry: ry }, otherProps), void 0);
}
//# sourceMappingURL=Ellipse.js.map